import React from "react";
import {component_tool, framework_tool} from "@/tool";
import {WizAuthority, WizDataAuthSelect,} from '../../../common'

const {Wizmessage, WizCol} = component_tool
const {WizAvatarUpload} = framework_tool;

const columns = (self) => {
  let initialValue = self.initialValue || {}
  return [
    {
      name: "id",
      formItem: {
        type: "hidden",
        initialValue:  initialValue.id,
      }
    },
    {
      title: "考试名称",
      name: "title",
      dataIndex: "title",
      formItem: {
        initialValue:  initialValue.title,
        maxlength: 20,
        rules: [
          {required: true, message: '请输入考试名称',}
        ],
      },
    },
    {
      title: "开始时间",
      name: "startDate",
      dataIndex: "startDate",
      formItem: {
        initialValue:  initialValue.startDate,
        type: 'date',
        format: 'YYYY-MM-DD HH:mm:ss',
        rules: [
          {required: true, message: '请输入开始时间',}
        ],
      },
    },
    {
      title: "结束时间",
      name: "endDate",
      dataIndex: "endDate",
      formItem: {
        initialValue:  initialValue.endDate,
        type: 'date',
        format: 'YYYY-MM-DD HH:mm:ss',
        rules: [
          {required: true, message: '请输入结束时间',}
        ],
      },
    },
    {
      title: "车联试卷编号",
      name: "cleId",
      dataIndex: "cleId",
      formItem: {
        initialValue:  initialValue.cleId,
        rules: [
          {required: true, message: '请输入车联试卷编号',}
        ],
      },
    },
    {
      title: "受众",
      name: "authCmd",
      dataIndex: "authCmd",
      formItem: {
        type: 'custom',
        rules: [
          {required: true, message: '请选择受众',}
        ],
        render: (record, form) => {
          record = initialValue;
          const {getFieldDecorator} = form;
          return (
            <WizCol style={{borderWidth: 1, borderColor: '#F0F2F5', borderStyle: 'solid', paddingTop: 20}}>
              {
                getFieldDecorator('authCmd', {initialValue: record.authInfo || {}})(
                  <WizDataAuthSelect hasRadioGroup={false}/>
                )
              }
            </WizCol>
          )
        }
      },
    },
    {
      title: "封面",
      name: "img",
      dataIndex: "img",
      formItem: {
        type: 'custom',
        render: (record, form) => {
          record = initialValue;
          const {getFieldDecorator} = form;
          return (
            <div>
              {
                getFieldDecorator('img', {
                  initialValue: record.img ?[
                    {fileId: record.img}
                  ] : []
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      let result = true;
                      const isLt1M = file.size / 1024 / 1024 < 2;
                      if (file.type.indexOf('image/') == -1) {
                        Wizmessage.error('只能上传图片类型,请重新选择!');
                        result = false;
                      } else if (!isLt1M) {
                        Wizmessage.error('图片不得超过2M!');
                        result = false;
                      }
                      return result;
                    }}
                  />
                )
              }
            </div>)
        }
      }
    },
  ]
}

export {columns}
